/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/10/27
 */
import React from 'react';
import {Route} from 'react-router-dom';
import {connect} from 'react-redux';
import getLoginURI from '../utils/getLoginURI';

const EnsureLoginRoute = ({ component: Component, isLogin, ...others }) =>
  <Route {...others} render={props => {
    if (isLogin) {
      return <Component {...props}/>
    }
    window.location.replace(getLoginURI(props.match.params.pid));
  }}/>;
;

export default connect(
  state => ({
    isLogin: state.user.userInfo.uid
  })
)(EnsureLoginRoute);



// WEBPACK FOOTER //
// ./src/routes/ensureLoginRoute.js